<template>
  <Section
    :id="id"
    :aria-label="
      t('search.paramSearchCriteria', {
        param: t('consolidation.openOrders'),
      })
    "
    class="ship-order-search-builder search-builder"
    data-class="filters flex flex-gap-1 flex-wrap"
  >
    <OriginFilter id="criteria-origin" v-model="criteria" />
    <DestinationFilter id="criteria-destination" v-model="criteria" />
    <RequestedPickupRangeFilter id="criteria-pickup" v-model="criteria" />
    <RequestedDeliveryRangeFilter id="criteria-delivery" v-model="criteria" />
  </Section>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';

import { ShipOrderSearchCriteria } from '@/model/consolidation';

import DestinationFilter from '@/components/shipmentPlanning/consolidation/search/DestinationFilter.vue';
import OriginFilter from '@/components/shipmentPlanning/consolidation/search/OriginFilter.vue';
import RequestedDeliveryRangeFilter from '@/components/shipmentPlanning/consolidation/search/RequestedDeliveryRangeFilter.vue';
import RequestedPickupRangeFilter from '@/components/shipmentPlanning/consolidation/search/RequestedPickupRangeFilter.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: ShipOrderSearchCriteria,
    default: () => new ShipOrderSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', modelValue: ShipOrderSearchCriteria): void;
}>();

const { t } = useI18n();

const { internalValue: criteria } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ShipOrderSearchCriteria>) =>
    new ShipOrderSearchCriteria(opts),
});
</script>

<style>
.ship-order-search-builder {
  .search-filter {
    flex-grow: 1;
    flex-basis: calc(50% - var(--sp-3));

    &.input-wrapper {
      .popup-inputgroup {
        .popup-inputgroup-card {
          width: max-content;
          top: calc(var(--sp-8) * -1);
        }
      }
    }
  }
}
</style>
